import { ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Seletor de mês (◀ Mês / Ano ▶) — porte do web novo do prospect (Fase 27),
 * restilizado pro slate dark do painel.
 */
interface Props {
  value: string;
  onChange: (month: string) => void;
  allowFuture?: boolean;
}

const MONTH_NAMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

function parseYM(ym: string): { year: number; month: number } {
  const m = /^(\d{4})-(\d{2})$/.exec(ym);
  const now = new Date();
  if (!m) return { year: now.getFullYear(), month: now.getMonth() };
  return { year: Number(m[1]), month: Number(m[2]) - 1 };
}

function formatYM(year: number, month: number): string {
  return `${year}-${String(month + 1).padStart(2, '0')}`;
}

export default function MonthSelector({ value, onChange, allowFuture = false }: Props) {
  const { year, month } = parseYM(value);
  const now = new Date();
  const isCurrentOrAhead =
    year > now.getFullYear() || (year === now.getFullYear() && month >= now.getMonth());

  function shift(delta: number) {
    const d = new Date(year, month + delta, 1);
    onChange(formatYM(d.getFullYear(), d.getMonth()));
  }

  const nextDisabled = !allowFuture && isCurrentOrAhead;

  return (
    <div className="flex items-center justify-center bg-surface border border-line rounded-2xl px-2 py-2">
      <button
        type="button"
        onClick={() => shift(-1)}
        className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-hover"
      >
        <ChevronLeft size={20} className="text-primary" />
      </button>

      <div className="flex-1 text-center">
        <p className="text-fg font-bold text-base">
          {MONTH_NAMES[month]} / {year}
        </p>
      </div>

      <button
        type="button"
        onClick={() => shift(1)}
        disabled={nextDisabled}
        className="w-10 h-10 rounded-full flex items-center justify-center hover:bg-hover disabled:opacity-40 disabled:hover:bg-transparent"
      >
        <ChevronRight
          size={20}
          className={nextDisabled ? 'text-faint' : 'text-primary'}
        />
      </button>
    </div>
  );
}
